import { RecurrenceStatus } from "gql/graphql";
import { useTranslations } from "use-intl";

/** Почему серия больше не срабатывает: закрыли вручную («закрыта») или кончилось расписание («завершена»). */
export function SeriesStatusLabel({ status }: { status: RecurrenceStatus }) {
  const t = useTranslations("TaskCompletion");

  if (status === RecurrenceStatus.Closed) {
    return t("Series closed");
  }

  return t("Series finished");
}
